import { Injectable, isDevMode, NgModule } from '@angular/core';
import { provideTransloco, Translation, TranslocoLoader, TranslocoModule } from '@jsverse/transloco';
import { provideTranslocoPersistLang } from '@jsverse/transloco-persist-lang';

import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  getTranslation(lang: string): Promise<Translation> {
    return import(`../../assets/i18n/${lang}.json`).then((res) => res.default);
  }
}

@NgModule({
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: ['en', 'cs'],
        defaultLang: 'cs',
        fallbackLang: 'cs',
        reRenderOnLangChange: true,
        prodMode: !isDevMode() || environment.production,
      },
      loader: TranslocoHttpLoader,
    }),
    provideTranslocoPersistLang({ storage: { useValue: localStorage } }),
  ],
})
export class TranslocoRootModule {}
